import styled from 'styled-components';

export const StyledTitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: 2.4rem;
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.main};
  text-align: center;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
  }
`;

export const StyledDivider = styled.div`
  height: 0.4rem;
  width: 10rem;
  border-radius: 0.2rem;
  background-color: ${({ theme }) => theme.colors.primary.main};
  margin-top: 1.5rem;
`;

export const StyledTitleContainer = styled.div<{ isLeft?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ isLeft }) => (isLeft ? 'flex-start' : 'center')};
  margin-bottom: 3rem;
`;
